// Storage helpers retained for the current tuition UI. No demo records are seeded.
export const TUITION_MODULE_KEYS = {
  STUDENT_MANAGEMENT: "student_management", TEACHER_MANAGEMENT: "teacher_management",
  ATTENDANCE: "attendance", ASSESSMENTS: "assessments_grading",
  FEES_FINANCIALS: "fees_financials", ONLINE_CLASSES: "online_classes",
  PARENT_REMINDERS: "parent_reminders",
};

export const TUITION_MODULE_DEFINITIONS = [
  { key: TUITION_MODULE_KEYS.STUDENT_MANAGEMENT, label: "Student Admissions & Records", description: "Create and manage student records, batches, and enrollment profiles.", defaultEnabled: true, category: "Core Academics" },
  { key: TUITION_MODULE_KEYS.TEACHER_MANAGEMENT, label: "Teacher & Faculty Management", description: "Manage staff, subject assignments, batches, and salary structures.", defaultEnabled: true, category: "Staffing" },
  { key: TUITION_MODULE_KEYS.ATTENDANCE, label: "Batch Attendance Tracking", description: "Record daily attendance by subject and batch.", defaultEnabled: true, category: "Core Academics" },
  { key: TUITION_MODULE_KEYS.ASSESSMENTS, label: "Assessments, Tests & Grading", description: "Record marks, grades, and feedback.", defaultEnabled: true, category: "Examinations" },
  { key: TUITION_MODULE_KEYS.FEES_FINANCIALS, label: "Fee Management & Financial Analytics", description: "Track student fees, salaries, and cash flow.", defaultEnabled: true, category: "Financials" },
  { key: TUITION_MODULE_KEYS.ONLINE_CLASSES, label: "Live Online Classes & Direct Join", description: "Schedule live lectures and record duration-based attendance.", defaultEnabled: true, category: "E-Learning" },
  { key: TUITION_MODULE_KEYS.PARENT_REMINDERS, label: "Parent Contact & Fee Reminders", description: "Access parent contacts and send fee reminders.", defaultEnabled: true, category: "Communication" },
];

const STORAGE_KEYS = {
  INSTITUTES: "classnx:tuition:institutes", STUDENTS: "classnx:tuition:students",
  TEACHERS: "classnx:tuition:teachers", SALARIES: "classnx:tuition:salaries",
  CLASSES: "classnx:tuition:classes", MEETING_ATTENDANCE: "classnx:tuition:meeting_attendance_logs",
};
const LEGACY_DEMO_IDS = new Set([
  "tuition-apex-101", "tuition-bright-102", "tuition-zenith-103",
  "stu-101", "stu-102", "stu-103", "stu-104", "stu-105",
  "tea-201", "tea-202", "tea-203", "tea-204", "sal-501", "sal-502", "sal-503",
  "cls-801", "cls-802", "cls-803",
]);

const readRecords = (key) => {
  try {
    const raw = localStorage.getItem(key);
    const records = raw ? JSON.parse(raw) : [];
    const cleaned = Array.isArray(records) ? records.filter((item) => !LEGACY_DEMO_IDS.has(item?.id)) : [];
    if (!Array.isArray(records) || cleaned.length !== records.length) localStorage.setItem(key, JSON.stringify(cleaned));
    return cleaned;
  } catch { return []; }
};
const saveRecords = (key, records, label) => {
  try { localStorage.setItem(key, JSON.stringify(Array.isArray(records) ? records : [])); }
  catch (error) { console.error(`Unable to save ${label}:`, error); }
};
const forTenant = (records, tuitionId) => tuitionId ? records.filter((item) => item.tuitionId === tuitionId) : records;

export const getStoredTuitionInstitutes = () => readRecords(STORAGE_KEYS.INSTITUTES);
export const saveStoredTuitionInstitutes = (items) => saveRecords(STORAGE_KEYS.INSTITUTES, items, "tuition institutes");
export const getStoredStudents = (id) => forTenant(readRecords(STORAGE_KEYS.STUDENTS), id);
export const saveStoredStudents = (items) => saveRecords(STORAGE_KEYS.STUDENTS, items, "students");
export const getStoredTeachers = (id) => forTenant(readRecords(STORAGE_KEYS.TEACHERS), id);
export const saveStoredTeachers = (items) => saveRecords(STORAGE_KEYS.TEACHERS, items, "teachers");
export const getStoredSalaries = (id) => forTenant(readRecords(STORAGE_KEYS.SALARIES), id);
export const saveStoredSalaries = (items) => saveRecords(STORAGE_KEYS.SALARIES, items, "salaries");
export const getStoredOnlineClasses = (id) => forTenant(readRecords(STORAGE_KEYS.CLASSES), id);
export const saveStoredOnlineClasses = (items) => saveRecords(STORAGE_KEYS.CLASSES, items, "online classes");

export const recordMeetingAttendance = (record) => {
  try {
    const logs = readRecords(STORAGE_KEYS.MEETING_ATTENDANCE);
    logs.unshift({ id: `att-log-${Date.now()}-${Math.random().toString(36).substring(2, 7)}`, timestamp: new Date().toISOString(), ...record });
    localStorage.setItem(STORAGE_KEYS.MEETING_ATTENDANCE, JSON.stringify(logs));
    return true;
  } catch (error) { console.error("Failed to record meeting attendance:", error); return false; }
};
export const getMeetingAttendanceLogs = (meetingId) => {
  const logs = readRecords(STORAGE_KEYS.MEETING_ATTENDANCE);
  return meetingId ? logs.filter((item) => item.meetingId === meetingId) : logs;
};
